import React, { useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import API from "../../api";

function useQuery() {
  const { search } = useLocation();
  return useMemo(() => new URLSearchParams(search), [search]);
}

export default function ResetPassword() {
  const q = useQuery();
  const navigate = useNavigate();

  const userId = q.get("id");
  const token = q.get("token");

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");
  const [ok, setOk] = useState("");

  const validate = () => {
    if (!userId) return "Missing id in URL.";
    if (!token) return "Missing token in URL.";
    if (!password || !confirmPassword) return "Both fields are required.";
    if (password.length < 6) return "Password must be at least 6 characters.";
    if (password !== confirmPassword) return "Passwords do not match.";
    return "";
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    const msg = validate();
    if (msg) return setErr(msg);

    setLoading(true);
    setErr("");
    setOk("");

    try {
      await API.post("/auth/reset-password", {
        userId: Number(userId),
        token,
        password,
        confirmPassword,
      });

      setOk("Password reset successfully. Redirecting to login...");
      setTimeout(() => navigate("/login"), 800);
    } catch (e2) {
      console.error(e2);
      setErr(
        e2?.response?.data?.error ||
          e2?.response?.data?.message ||
          "Failed to reset password."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: 20, display: "flex", justifyContent: "center" ,height: '100vh', alignItems: 'center' }}>
      <div
        style={{
          width: 420,
          maxWidth: "95vw",
          border: "1px solid #eee",
          borderRadius: 12,
          padding: 16,
          background: "#fff",
        }}
      >
        <h2 style={{ marginTop: 0 }}>Reset Password</h2>

        {err && (
          <div
            style={{
              background: "#ffecec",
              border: "1px solid #ffb8b8",
              color: "#8a1f1f",
              padding: 10,
              borderRadius: 10,
              marginBottom: 10,
            }}
          >
            {err}
          </div>
        )}
        {ok && (
          <div
            style={{
              background: "#eaffea",
              border: "1px solid #b7f0b7",
              color: "#155d15",
              padding: 10,
              borderRadius: 10,
              marginBottom: 10,
            }}
          >
            {ok}
          </div>
        )}

        <form onSubmit={onSubmit}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 6,
              marginBottom: 12,
            }}
          >
            <label style={{ fontSize: 12, fontWeight: 700 }}>
              New Password
            </label>
            <input
              type="password"
              value={password}
              onChange={(ev) => setPassword(ev.target.value)}
              placeholder="Enter password"
              autoComplete="new-password"
              style={{
                padding: 10,
                borderRadius: 10,
                border: "1px solid #d9d9d9",
              }}
            />
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 6,
              marginBottom: 12,
            }}
          >
            <label style={{ fontSize: 12, fontWeight: 700 }}>
              Confirm Password
            </label>
            <input
              type="password"
              value={confirmPassword}
              onChange={(ev) => setConfirmPassword(ev.target.value)}
              placeholder="Confirm password"
              autoComplete="new-password"
              style={{
                padding: 10,
                borderRadius: 10,
                border: "1px solid #d9d9d9",
              }}
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            style={{
              width: "100%",
              padding: 10,
              borderRadius: 10,
              border: "1px solid #111",
              background: "#111",
              color: "#fff",
              fontWeight: 700,
              cursor: "pointer",
            }}
          >
            {loading ? "Saving..." : "Reset Password"}
          </button>

          <div style={{ marginTop: 10, fontSize: 12, color: "#666" }}>
            Password must be at least 6 characters.
          </div>
        </form>
      </div>
    </div>
  );
}
